import { h, Component } from 'preact';
import { Router } from 'preact-router';
// NOTE: Code-splitting is automated for routes

import Home from './home/Home';
import PageSelector from './pages/PageSelector';

export default class App extends Component {

	render() {
		return (
			<div id="app">
				<Router>
					<PageSelector path="/" />
					<Home path="/:pageId" />
				</Router>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/app.js